import NotFound from "components/NotFound";
import Page from "components/Page";
import PageVersionContext from "components/PageVersionContext";
import React, { useContext } from "react";
import { withRouter } from "react-router-dom";

const PageSwitcher = () => {
  const { currentPageVersion, loading } = useContext(PageVersionContext);

  if (!currentPageVersion && !loading) {
    return <NotFound />;
  }
  return <Page page={currentPageVersion} />;
};

export default withRouter(PageSwitcher);
